import * as React from 'react';
import { Avatar, LinkButton, UIHeading1, UIHeading4, UIText1 } from '@cian/ui-kit';
import { IBuilder } from '../../types/project';
import * as styles from './AuthorInfo.css';
import { NBSP } from '../../constants/symbols';
import { ContactsDisclaimer } from '../ContactsDisclaimer';

interface IAuthorInfoProps extends Omit<IBuilder, 'phone' | 'lastYearConstructCount' | 'projectsCount'> {
  lastYearConstructCount?: string;
  projectsCount?: string;
  phoneButton: React.ReactNode;
  callbackButton?: React.ReactNode;
  phoneVisible: boolean;
}

export const AuthorInfo: React.FC<IAuthorInfoProps> = ({
  name,
  logo,
  url,
  foundationYear,
  projectsCount,
  lastYearConstructCount,
  phoneButton,
  callbackButton,
  phoneVisible,
}) => {
  return (
    <div className={styles['container']}>
      <div className={styles['info']}>
        <div>
          <UIHeading4>Автор объявления</UIHeading4>
          <div className={styles['name']}>
            <UIHeading1>{name}</UIHeading1>
          </div>
          <div className={styles['factoids']}>
            {!!foundationYear && <UIText1>Год основания: {foundationYear}</UIText1>}
            {projectsCount && <UIText1>Доступно: {projectsCount}</UIText1>}
            {lastYearConstructCount && (
              <UIText1>
                Построили в{NBSP}прошлом году: {lastYearConstructCount}
              </UIText1>
            )}
          </div>
        </div>
        <Avatar type="builder" size={70} src={logo} />
      </div>
      <div className={styles['actions']}>
        {phoneButton}
        {callbackButton}
        <LinkButton theme="fill_white_primary" size="XS" href={url} target="_blank">
          Подробнее о компании
        </LinkButton>
      </div>
      {phoneVisible && (
        <div className={styles['disclaimer']}>
          <ContactsDisclaimer />
        </div>
      )}
    </div>
  );
};
